import { Toast } from 'primereact/toast';
import React, { createContext, useContext, useRef, useState, useEffect } from 'react';
import { i18n, initializeI18n } from '../../../localization/i18n';

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const toast = useRef(null);
  const [currentLanguage, setCurrentLanguage] = useState(null);

  useEffect(() => {
    if (!i18n.isInitialized) {
      initializeI18n().then(() => {
        setCurrentLanguage(i18n.language);
      });
    } else {
      setCurrentLanguage(i18n.language);
    }
  }, []);

  const showToast = (severity, summary, detail, life = 3000) => {
    toast.current?.show({
      severity,
      summary,
      detail,
      life: 3000
    });
  };

  const showSuccess = (detail) => {
    showToast('success', currentLanguage === 'en' ? 'Success' : currentLanguage === 'vi' ? 'Thành công' : '성공', detail);
  };

  const showError = (detail) => {
    showToast('error', currentLanguage === 'en' ? 'Error' : currentLanguage === 'vi' ? 'Lỗi' : '오류', detail);
  };

  const showInfo = (detail) => {
    showToast('info', currentLanguage === 'en' ? 'Info' : currentLanguage === 'vi' ? 'Thông tin' : '정보', detail);
  };

  const showWarn = (detail) => {
    showToast('warn', currentLanguage === 'en' ? 'Warning' : currentLanguage === 'vi' ? 'Cảnh báo' : '경고', detail);
  };

  const value = {
    showToast,
    showSuccess,
    showError,
    showInfo,
    showWarn
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
      <Toast 
        ref={toast} 
        position="top-right"
        className="keduall-toast hight-index"
      />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
